import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Tab, Tabs } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FilterFieldTabLoad() {
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Tabs, {
    TabIndicatorProps: {
      sx: function sx(theme) {
        return {
          display: 'block',
          height: theme.spacing(0.5),
          borderRadius: 2
        };
      }
    },
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    },
    disabled: true,
    indicatorColor: "primary",
    value: 0,
    children: [/*#__PURE__*/_jsx(Tab, {
      sx: {
        backgroundColor: 'Background !important',
        px: 5
      },
      disabled: true,
      label: intl.formatMessage({
        id: "zjIIl+",
        defaultMessage: [{
          "type": 0,
          "value": "Facility"
        }]
      })
    }), /*#__PURE__*/_jsx(Tab, {
      sx: {
        backgroundColor: 'Background !important',
        px: 5
      },
      disabled: true,
      label: intl.formatMessage({
        id: "xaj9Ba",
        defaultMessage: [{
          "type": 0,
          "value": "Provider"
        }]
      })
    }), /*#__PURE__*/_jsx(Tab, {
      sx: {
        backgroundColor: 'Background !important',
        px: 5
      },
      disabled: true,
      label: intl.formatMessage({
        id: "WxpO4b",
        defaultMessage: [{
          "type": 0,
          "value": "Appointment Type"
        }]
      })
    }), /*#__PURE__*/_jsx(Tab, {
      sx: {
        backgroundColor: 'Background !important',
        px: 5
      },
      disabled: true,
      label: intl.formatMessage({
        id: "qIgdO6",
        defaultMessage: [{
          "type": 0,
          "value": "Custom Filter"
        }]
      })
    })]
  });
}